@use "../../../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../../../styles/Colors.scss" as Colors;

$var-menu-min-height: 300px;

.menu {
	min-height: $var-menu-min-height;
	width: unset !important;
	cursor: default;
	margin-top: 0;
	margin-bottom: 0;

	&:global(.show) {
		display: flex !important;
	}
}

.content {
	max-height: 400px;
	display: flex;
	flex-direction: row;
	align-items: stretch;
}

.tagsPane {
	width: 260px;
	border-right: solid 1px Colors.$col-design-grey13;
	display: flex;
	flex-direction: column;
	align-items: stretch;

	.title {
		padding: Constants.$val-spacing-s;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		color: Colors.$col-design-grey500;
	}

	.tagFilterList {
		padding: 0 Constants.$val-spacing-s;
		overflow-x: auto;
		flex: 1;

		.tagItem {
			padding: Constants.$val-spacing-s 0;
		}
	}
}

.costsPane {
	display: flex;
	flex-direction: column;
	align-items: stretch;

	.costsList {
		flex: 1;
		overflow-x: auto;
	}

	.emptyMessageContainer {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: Constants.$val-spacing-m;
		
		.message {
			font-size: Constants.$val-fontSizeRegular;
			color: Colors.$col-design-grey10;
		}
	}
}

.sourceFilters {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
}

.searchInputContainer {
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
}

.selectedItem {
	display: flex;
	flex-direction: row;
	align-items: center;

	.name {
		flex: 1;
		margin-left: Constants.$val-spacing-s;
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-lineHeightSmall;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
